import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { Loader } from '@/components';
import DropdownButton from './DropdownButton';

const SeasonFilter = ({
  options,
  setRecruitingSeasonId,
  onChangeSeason,
}) => {
  const [selectedSeason, setSelectedSeason] = useState('');
  const [seasonOptions, setSeasonOptions] = useState([]);

  useEffect(() => {
    options.map((option) => {
      if (option.is_current) {
        setSelectedSeason(option.label);
        setRecruitingSeasonId(option.value);
      }
    });
  }, [options, setRecruitingSeasonId]);

  useEffect(() => {
    const tempOptions = options.map((option) => {
      return {
        ...option,
        name: option.label,
        onClick: () => setSelectedSeason(option.value),
      };
    });
    setSeasonOptions(tempOptions);
  }, [options]);

  const onFilterChange = (option) => {
    setRecruitingSeasonId(option.value);
    setSelectedSeason(option.name);

    onChangeSeason();
  };

  return (
    seasonOptions.length > 0
      ? (
        <DropdownButton
          options={seasonOptions}
          label={selectedSeason}
          onChange={onFilterChange}
        />
      )
      : <Loader />
  );
};

SeasonFilter.propTypes = {
  options: PropTypes.array,
  setRecruitingSeasonId: PropTypes.func,
  onChangeSeason: PropTypes.func,
};

export default SeasonFilter;
